<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Automatische Geräteerkennung"}}</h4>
</div>
<div class="modal-body">
	{{#COMPARE percentDisplay '!=' '100' }}
	<div class="progress progress-lg m-b-5">
		<div class="progress-bar" role="progressbar" style="width: {{percent}}%;">
		{{percentDisplay}} %
		</div>
	</div>
	{{/COMPARE}}
	<div class="row m-t-20">
		{{#unless scanCancelled}}
		{{#each devices}}
		<div class="col-xs-3">
			<div class="container" {{#if @last}}{{#if ../foundNewDevice}}id="animationSandbox"{{/if}}{{/if}}>
				<img src="img/devices/{{image}}" style="max-width: 100%; max-height: 100%; width: auto; height: auto;" onerror="this.onerror=null;this.src='img/devices/modbus/unknown.png';" />
				<span class="badge badge-danger badge-unit-id">
					{{type}}{{#COMPARE unit '>' '0'}} @ {{unit}}{{/COMPARE}}
				</span>
			</div>
		</div>
		{{#COMPARE @index 'rowEnd' 4}}
		<div class="clearfix" />
		{{/COMPARE}}
		{{else}}
		<div class="col-xs-12">
			{{#COMPARE percentDisplay '!=' '100' }}
				{{TR "Geräte werden gesucht ..."}} <i class="fa fa-spin fa-spinner"></i>
			{{else}}
				<div class="alert alert-danger">
					{{TR "Keine angeschlossenen Geräte gefunden."}}
				</div>
			{{/COMPARE}}
		</div>
		{{/each}}
		{{else}}
		<div class="col-xs-12">
			{{TR "Geräte werden hinzugefügt ..."}} <i class="fa fa-spin fa-spinner"></i>
		</div>
		{{/unless}}
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	{{#unless scanCancelled}}
	<button class="btn btn-primary" id="js-save"
		{{#unless devices.length}}disabled="disabled"{{/unless}}
		{{#if inAdding}}disabled="disabled"{{/if}}
	>{{TR "Hinzufügen"}}</button>
	{{/unless}}
</div>
